module.exports = __webpack_public_path__ + "static/media/appointed-officer.d2c67119.svg";